// The global top bar carries one contextual date picker (app-shell-redesign AC4).
// Its mode is driven by the active page's routeMap nav key — NOT hardcoded in the
// bar — so adding/retargeting a page is a one-line edit here, mirroring how
// routeMap owns nav → page.
//
//   day   — a single day matters:   Daily, Messages
//   month — a whole month matters:  Rota (key 'schedule')
//   year  — a whole year matters:   Finances (year-grained analytics)
//   null  — no date context:        Bookings, Dogs & Owners, Account (greyed/disabled)

export type DatePickerMode = 'day' | 'month' | 'year';

const DAY_PAGES = new Set(['today', 'messages']);
const MONTH_PAGES = new Set(['schedule']);
const YEAR_PAGES = new Set(['finances']);

/** Resolve the top-bar date-picker mode for a page, or null to disable it. */
export function datePickerMode(navKey: string): DatePickerMode | null {
  if (DAY_PAGES.has(navKey)) return 'day';
  if (MONTH_PAGES.has(navKey)) return 'month';
  if (YEAR_PAGES.has(navKey)) return 'year';
  return null;
}
